// import React from 'react'
import styled from 'styled-components'

import {Box} from 'rebass'


export const PopupWrapper = styled(Box)`
min-width: 500px;
max-width: 550px;
 @media(max-width: 450px){
 min-width: 400px;
 max-width: 400px;

 }
`

export const formButtonProps = {
	m: 1,
	mt: 2,
	variant: 'main'
};

export const buttonMarginTop = 3